import { catEstatusProceso } from "../constant/catEstatusProceso"

export const esFinalizado = (estatus) => {
    if (estatus === catEstatusProceso.BAJA_INACTIVIDAD
        || estatus === catEstatusProceso.FINALIZADO
        || estatus === catEstatusProceso.CANCELADO_CLIENTE
        || estatus === catEstatusProceso.CANECLADO_AGENTE
        || estatus === catEstatusProceso.CAMBIO_VIAJE)
        return true
    return false
}